import{ga4 as o}from"@edikk-edikk/ga4";const t=i=>{i&&o.initialize(i)};export{t as useInitGoogleAnalytics};
